// @flow

import accounting from 'accounting'

export default (amount: number): string => accounting.formatMoney(amount, '$', 5, ' ', '.').replace(/\.?0+$/, '')
